import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { environment } from '../environments/environment';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { FormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { AccountMenuComponent } from './account/account-menu/account-menu.component';
import { SharedComponentsModule } from './cart/shared-components.module';
import { ComponentsModule } from './components/components.module';
import { WhatsappFabComponent } from './components/whatsapp-fab/whatsapp-fab.component';
import { LIB_CONFIG } from './shared-lib/core/lib-config';
import { AnalyticsService } from './shared/analytics.service';
import { PaginatorIntlService } from './shared/custom-paginator';
import { ShippingService } from './shared/services/shipping.service';

registerLocaleData(localeEs, 'es-ES');

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent], imports: [SharedComponentsModule,
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios',
      innerHTMLTemplatesEnabled: true
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    ComponentsModule,
    BrowserModule,
    FormsModule,
    LottieComponent,
    AccountMenuComponent,
    WhatsappFabComponent], providers: [
      provideLottieOptions({
        player: () => import('lottie-web/build/player/lottie_svg'),
      }),
      provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
      provideFirestore(() => getFirestore()),
      provideStorage(() => getStorage()),
      provideFunctions(() => getFunctions(getApp(), 'europe-west1')),
      provideAuth(() => getAuth()),
      provideAnalytics(() => getAnalytics()),
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: LOCALE_ID, useValue: 'es-ES' },
      { provide: 'FIREBASE_REGION', useValue: 'europe-west1' },
      { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
      { provide: 'googleTagManagerId', useValue: 'GTM-NJV2JD5' },
      {
        provide: MatPaginatorIntl,
        useFactory: () => {
          const service = new PaginatorIntlService();
          service.injectTranslateService();
          return service;
        }
      },
      // { provide: ORIGIN, useValue: 'http://124c45f0.ngrok.io' },
      ScreenTrackingService,
      UserTrackingService,
      AnalyticsService,
      ShippingService,
      provideHttpClient(withInterceptorsFromDi()),
      {
        provide: LIB_CONFIG, useValue: {
          apiUrl: environment.apiUrl,
          mapsApiKey: environment.maps.apiKey,
          apiFilesUrl: environment.apiFilesUrl,
          apiHl: environment.apiHl
        }
      },
    ]
})
export class AppModule {
}
